/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { columnsPropType } from '../../types';
import styles from './TableRow.module.css';
import { Link } from 'react-router-dom';
import { dateFormat, downloadData, getPlantValue } from "../../../../constants/Utils";
import { dateFieldHeader } from '../../../../constants/constVariables';

const TableRow = ({
    classNames,
    columns,
    index,
    row,
    style,
    snapshot,
    handlePopoverOpen,
    handlePopoverClose,
    onCopy,
    rowClick,
    onClickPath
}) => {

    const getFlexAlignment = alignment => {
        if (alignment === 'center') return 'center';
        if (alignment === 'right') return 'flex-end';
        return 'flex-start';
    };

    return (
        <div
            className={clsx(
                styles.tableRow,
                row.isSelected && styles.defaultSelectedRow,
                classNames.tableRowClassName instanceof Function
                    ? classNames.tableRowClassName(row, snapshot?.isDragging)
                    : classNames.tableRowClassName,
            )}
            style={{
                ...style,
            }}
        >
            {columns.map(col => {
                const renderColumnCell = () =>
                    col.render && row ? (

                        col.render(row, index + 1, {
                            openEllipsisPopupForEventWithText: handlePopoverOpen,
                            closeEllipsisPopup: handlePopoverClose,
                            onCopy,
                        })
                    ) : (
                        onClickPath ?
                            <Link state={{ data: row }} to={onClickPath} >
                                <div
                                    onDoubleClick={() => onCopy(row[col.field] ? row[col.field] : null)}
                                    className={styles.ellipsisText}
                                    onMouseEnter={e => handlePopoverOpen(e, row[col.field] ? row[col.field] : null)}
                                    onMouseLeave={() => handlePopoverClose()}
                                    style={{ textAlign: col.alignment || 'left' }}
                                    title="Click to view"
                                >
                                    {(row[col.field] && row[col.field] !== "") ?
                                        // col.field ==="last_sync_date" || col.field === "updated_at" || col.field === "time" || col.field === "dispatch_updated_at" ?       
                                        dateFieldHeader.includes(col.field) ?
                                            dateFormat(row[col.field]) :
                                            row[col.field] : "-"}
                                </div>
                            </Link>
                            :
                            <div
                                onDoubleClick={() => onCopy(row[col.field] ? row[col.field] : null)}
                                className={styles.ellipsisText}
                                onMouseEnter={e => handlePopoverOpen(e, row[col.field] ? row[col.field] : null)}
                                onMouseLeave={() => handlePopoverClose()}
                                style={{ textAlign: col.alignment || 'left' }}
                            >
                                {(row[col.field] && row[col.field] !== "") ?
                                    // col.field === "last_sync_date" || col.field === "updated_at" || col.field === "time" || col.field === "dispatch_updated_at" ?
                                    dateFieldHeader.includes(col.field) ?
                                        dateFormat(row[col.field]) :
                                        row[col.field] : "-"}
                            </div>
                    );

                return (
                    <div
                        className={clsx(styles.tableCell, classNames.tableCellClassName)}
                        style={{
                            height: '100%',
                            ...col.style,
                            ...col.cellStyles,
                            display: 'inline-flex',
                            alignItems: 'center',
                            width: col.width,
                            justifyContent: getFlexAlignment(col.alignment),
                        }}
                        key={`${row.asn}-${col.field}`}
                    >
                        {renderColumnCell()}
                    </div>
                );
            })}
        </div>
    );
};

TableRow.propTypes = {
    classNames: PropTypes.shape({
        tableContainerClassName: PropTypes.string,
        tableClassName: PropTypes.string,
        tableRowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
        tableHeadClassName: PropTypes.string,
        tableCellClassName: PropTypes.string,
    }),
    columns: columnsPropType,
    index: PropTypes.number,
    row: PropTypes.shape({
        asn: PropTypes.string,
        isSelected: PropTypes.bool,
    }).isRequired,
    style: PropTypes.object,
    snapshot: PropTypes.object,
    handlePopoverOpen: PropTypes.func.isRequired,
    handlePopoverClose: PropTypes.func.isRequired,
    onCopy: PropTypes.func.isRequired,
    rowClick: PropTypes.func
};

export default TableRow;
